import { render, staticRenderFns } from "./VipAlert.vue?vue&type=template&id=5a3d769a&scoped=true&"
import script from "./VipAlert.vue?vue&type=script&lang=js&"
export * from "./VipAlert.vue?vue&type=script&lang=js&"
import style0 from "./VipAlert.vue?vue&type=style&index=0&id=5a3d769a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d769a",
  null
  
)

export default component.exports